import { render, staticRenderFns } from "./SeminarEventFilter.vue?vue&type=template&id=2a45dd9a&scoped=true&"
import script from "./SeminarEventFilter.vue?vue&type=script&lang=js&"
export * from "./SeminarEventFilter.vue?vue&type=script&lang=js&"
import style0 from "./SeminarEventFilter.vue?vue&type=style&index=0&id=2a45dd9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a45dd9a",
  null
  
)

export default component.exports